__webpack_require__.p = "/umrah-booking2/";